import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import jwt_decode, { JwtPayload } from 'jwt-decode';
import { Router } from '@angular/router';

interface Refresh {
  token: {
    jwt: string;
  };
  refresh: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private urlProd: string = environment.apiRoot;
  private userToken: string = '';
  private userEmail: string = '';
  private refreshUserToken: string = '';
  private userType: string = '';

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {
    this.readToken();
    this.readUserEmail();
    this.readRefreshToken();
    this.readTypeUser();
  }

  login(usuario: any) {
    const authData = {
      ...usuario,
    };
    console.log(this.urlProd);
    return this.http.post(`${this.urlProd}auth/login`, authData).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 500) {
          return throwError('Upsi');
        }
        if (error.status === 401) {
          return throwError('Unautorized');
        }
        return throwError('');
      }),
      map((resp: any) => {
        this.saveToken(resp.data.token);
        this.saveUser(resp.data.user.email);
        this.saveRefresh(resp.data.refresh);
        this.saveUserType(resp.data.user.type);
        console.log(resp.data.user.type);
        return resp.data;
      }),
    );
  }

  test() {
    console.log(`${this.urlProd}challenges/exercises/all`);

    return this.http.get(`${this.urlProd}challenges/exercises/all`).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 500) {
          return throwError('Upsi');
        }
        if (error.status === 401) {
          return throwError('Unauthorized');
        }
        return throwError('');
      }),
      map((resp: any) => {
        console.log(resp);
        return resp;
      }),
    );
  }

  saveUserType(type: string) {
    this.userType = type;
    localStorage.setItem('type', this.userType);
  }

  private saveToken(idToken: string) {
    this.userToken = idToken;
    localStorage.setItem('token', idToken);
  }

  private saveUser(email: string) {
    this.userEmail = email;
    localStorage.setItem('user', email);
  }

  private saveRefresh(refresh: string) {
    this.refreshUserToken = refresh;
    localStorage.setItem('refrehsToken', refresh);
  }

  readToken() {
    if (localStorage.getItem('token')) {
      this.userToken = localStorage.getItem('token') || '';
    } else {
      this.userToken = '';
    }
    return this.userToken;
  }

  readTypeUser() {
    if (localStorage.getItem('type')) {
      this.userType = localStorage.getItem('type') || '';
    } else {
      this.userType = '';
    }
    return this.userType;
  }

  readUserEmail() {
    if (localStorage.getItem('user')) {
      this.userEmail = localStorage.getItem('user') || '';
    } else {
      this.userEmail = '';
    }
    return this.userEmail;
  }

  readRefreshToken() {
    if (localStorage.getItem('refrehsToken')) {
      this.refreshUserToken = localStorage.getItem('refrehsToken') || '';
    } else {
      this.refreshUserToken = '';
    }
    return this.userEmail;
  }

  isAuthenticated(): boolean {
    if (this.userToken?.length > 2) {
      return true;
    }
    return false;
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('refrehsToken');
    location.reload();
  }

  recovery(data: any) {
    return this.http.post(`${this.urlProd}auth/recovery`, { email: data });
  }

  resetPassword(data: any) {
    const { recoveryToken, password } = data;
    return this.http.post(
      `${this.urlProd}auth/change-password?token=${recoveryToken}`,
      { password },
    );
  }

  changePassword(body: any, token: string) {
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.http.post(`${this.urlProd}auth/change-pass`, body, {
      headers: header,
    });
  }

  sendRefreshToken(refreshtoken: string): Observable<any> {
    const header = new HttpHeaders({
      refresh: `${refreshtoken}`,
    });
    return this.http
      .get<Refresh>(`${this.urlProd}auth/refresh-token`, { headers: header })
      .pipe(
        tap((response: Refresh) => {
          this.saveToken(response.token.jwt);
          this.saveRefresh(response.refresh);
        }),
      );
  }

  isValidToken() {
    const token = this.userToken;
    if (!token) {
      return false;
    }
    const decodeToken = jwt_decode<JwtPayload>(this.userToken);
    if (decodeToken && decodeToken?.exp) {
      const tokenDate = new Date(0);
      const today = new Date();
      tokenDate.setUTCSeconds(decodeToken.exp);
      return tokenDate.getTime() > today.getTime();
    }
    return false;
  }

  isValidRefreshToken() {
    const token = this.refreshUserToken;
    if (!token) {
      return false;
    }
    const decodeToken = jwt_decode<JwtPayload>(this.userToken);
    if (decodeToken && decodeToken?.exp) {
      const tokenDate = new Date(0);
      const today = new Date();
      tokenDate.setUTCSeconds(decodeToken.exp);
      return tokenDate.getTime() > today.getTime();
    }
    return false;
  }

  isAdmin() {
    console.log(this.userType);
    return this.userType === 'Admin';
  }

  getAdmin() {
    return this.userType;
  }
}
